import { render } from "./2022-11-12-Vue2 Vue3.md?vue&type=template&id=6260c50e"
const script = {}
script.render = render

export default script